export default "images/nameBack.png";